import React from "react";
import "./Placeholder.scss";
const Placeholder = ({ image, title, description }) => {
  return (
    <div className="placeholder_wrap">
      <div className="placeholder_content">
        <img src={image} alt="" />
        {title && <h4>{title}</h4>}

        {description && <p>{description}</p>}
      </div>
    </div>
  );
};

export default Placeholder;
